export const SHOP_LIST = 'cdb/shop/listnear'
export const QR_CODE = 'cdb/cabinet/checkisok'
export const ZH_CODE = 'cdb/cabinet/zhorder'

export const ORDER_TEMP = 'cdb/cabinet/createorder'
export const ORDER_CZ = 'cdb/cabinet/order'
export const ORDER_CHECK = 'cdb/cabinet/ordercheck'
export const ORDER_PAYU = '/cdb/payment/payU/multiCurrency/createOrder'
export const ORDER_PAYU_CONFIRM = '/cdb/payment/payU/multiCurrency/authConfirm/payment'
export const ABBPAY_PREAUTH = '/cdb/payment/abbpay/preauth'
export const ABBPAY_AUTHCONFIRM = '/cdb/payment/abbpay/authConfirm'
export const ABBPAY_RECHARGE = '/cdb/payment/abbpay/recharge'

export const EVERYPAY_PRE_PAY = 'cdb/payment/everypay/multicurrency/prepay'
export const EVERYPAY_CONFIRM = 'cdb/payment/everypay/multicurrency/payment/query'
export const EVERYPAY_PAY_ORDER = 'cdb/payment/everypay/multicurrency/pay/order'
export const EVERYPAY_BALANCE_CHARGE = 'cdb/payment/everypay/multicurrency/balance/charge'
export const ORDER_GOPAY_CONFIRM = '/cdb/payment/goPay/multiCurrency/authConfirm/payment'
export const PAY_ORDER_GOPAY = '/cdb/payment/goPay/multiCurrency/payOrder'
